import { Nullable } from '~globals/types/commons';
import { ScheduleRouteWeeklyDayIndex } from '~services/scheduleRoute/types';

import { pluralize } from '../../commons';

import { ScheduleRouteRepetionDescriptionDayFormat } from './types';
import { DAY_NAME_FORMATS } from './constants';

export const buildBaseText = ({
  repeatInterval,
  singular,
  plural,
}: {
  repeatInterval: number;
  singular: string;
  plural?: string;
}): string => {
  const prefix = pluralize({
    singular,
    plural,
    count: repeatInterval,
    includeCount: true,
  });

  return `Cada ${prefix}`;
};

export const appendDaysToDescription = ({
  description,
  dayLabels,
}: {
  description: string;
  dayLabels: string[];
}): string => {
  if (!dayLabels.length) return description;

  return `${description} ${dayLabels.join(', ')}`;
};

export const sortWeeklyDays = (
  days: Nullable<ScheduleRouteWeeklyDayIndex[]>,
): ScheduleRouteWeeklyDayIndex[] => {
  if (!days) return [];

  return days.sort((a, b) => a - b);
};

export const normalizeAndSortWeeklyDays = (
  days: Nullable<ScheduleRouteWeeklyDayIndex[]>,
): ScheduleRouteWeeklyDayIndex[] => {
  if (!days) return [];

  const normalizeDays = Array.from(new Set(days)).filter(
    (d) => d >= 0 && d <= 6,
  );

  return sortWeeklyDays(normalizeDays);
};

export const getWeeklyDayLabels = ({
  days,
  format,
}: {
  days: ScheduleRouteWeeklyDayIndex[];
  format: ScheduleRouteRepetionDescriptionDayFormat;
}): string[] => {
  const formatter = DAY_NAME_FORMATS[format];

  return days.map((d) => formatter[d]);
};

export const transformRepetitionIntervalStringToArray = (
  repetitionIntervalString: Nullable<string>,
): Nullable<ScheduleRouteWeeklyDayIndex[]> => {
  if (repetitionIntervalString === null) return null;

  const repetitionIntervalArray = repetitionIntervalString
    .split(',')
    .map((interval) => Number(interval) as ScheduleRouteWeeklyDayIndex);

  return repetitionIntervalArray;
};
